<template>
  <div class="line-item"> 
      <div class="heading ml-2" style="display:flex;" @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE');">                   
        <v-btn class="missionbtn mx-0 pr-2"  flat>
          {{ missionGlobal.MIG_LIBELLE }} {{ $t("Simulation.Current") }} 
        </v-btn>        
        <v-btn class="mx-0" small icon @click.prevent="selectCurrentSimulation()"  :title="$t('Pilot.MissionDrawer.SelectMissionTooltip')"><v-icon :class="{active:bestFitMisId == null}">mdi-crosshairs-gps</v-icon></v-btn>
      </div>           
  </div> 
</template>
<script lang="ts">


import Vue from 'vue'
import Component from 'vue-class-component'
import { buildSimulationUIStateId,SimulationUiState } from '@/models/ui/SimulationUiState'
import { MapUiState } from '@/models/ui/MapUiState'
import { buildMissionPlanStateId } from '@/models/ui/MissionPlanUiState'
import { ISmartSimulation } from '@/models/iris/smartMission/ISmartSimulation'

@Component({
name: 'SimulationCurrentLine',  
props:{    
 
}
})
export default class SimulationCurrentLine extends Vue {      
  
  
  //le composant n'est utilisé que si une missionGlobal est sélectionnée
  get missionGlobal() {
    return this.$store.myGetters.originalAdmMissionGlobal
  }

  get uistatebyuiid() {    
    return this.$store.myGetters.uistatebyuiid
  }

  get map_uiid() {
    return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"map")
  }

  get mapState() { 
    //retourne un MapUiState    
    return this.uistatebyuiid(this.map_uiid) as MapUiState         
  }

  get bestFitMisId(){
    return this.mapState?.bestFitMisId
  }
    
  get missionPlanUiid() {
    return buildMissionPlanStateId(this.missionGlobal.MIG_ID || -1,"simulation")
  }
  
  selectCurrentSimulation()  {
    if(this.$store.myGetters.modifiedAdmMissionGlobal.MIG_ID != null) {
      this.$store.myActions.MISSIONGLOBAL_CANCEL_MODIFIED_ADM()      
      this.$store.myActions.UI_MISSIONPLAN_SET_MISSIONPLAN({
        uiid:this.missionPlanUiid,
        plan:(this.$store.myGetters.modifiedAdmMissionGlobal.config! as ISmartSimulation).mission_plan
      })
      this.$store.myActions.UI_SELECT_MISSION_MAP({id:null,uiid:this.map_uiid})
    }    
  }

}

</script> 

<style>

.rotate180{
  transform: rotate(-180deg);
}

.missionbtn .v-icon{
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)!important;
}

.testMission{
  font-style: italic;
  color: rgb(128, 128, 128)!important;
}

.line-item{
  border-bottom: 1px solid #eee;
}
.line-item .active{
  color: #4caf50!important;  
}

.line-item .heading{
  display: flex;
  flex-direction: row;
  align-items: center;  
}

.missionbtn{
  flex:1 0 auto;
}

.missionbtn .v-btn__content{
  justify-content: flex-start;
}

</style>